import { render, staticRenderFns } from "./ChatFileV2.vue?vue&type=template&id=5589cba4&scoped=true"
import script from "./ChatFileV2.vue?vue&type=script&lang=js"
export * from "./ChatFileV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5589cba4",
  null
  
)

export default component.exports